export default {
    getList: {
        getNoticeRuleList: async function (params) {
            let option = {
                url: '/api/v1/partner/notificationrules',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userNoticeRule.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getInfoList:async function (params) {
            let option = {
                url: '/api/v1/partner/dropdowns/notification',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userNoticeRule.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getSiteList: async function (params) {
            let option = {
                url: '/api/v1/partner/dropdown/sites?include_delegation=true',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userNoticeRule.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getUser: async function (params) {
            let option = {
                url: '/api/v1/partner/dropdown/users',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userNoticeRule.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
    },
    do: {
        add: async function (params) {
            let option = {
                url: '/api/v1/partner/notificationrule',
                type: 'post',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userNoticeRule.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        editor: async function (params) {
            let option = {
                url: '/api/v1/partner/notificationrule/' + params.id,
                type: 'put',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userNoticeRule.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        delete: async function (params) {
            let option = {
                url: '/api/v1/partner/notificationrule/' + params.id,
                type: 'delete',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userNoticeRule.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        }
    }
}